<template>
  <div
    style="height: 80%; min-width: 300px;"
    v-loading="cInventory == null || inventory == null || userId == null"
  >
    <el-table
      :data="cInventory"
      :height="windowHeight - 170"
      :default-sort="{prop:'date', order: 'descending'}"
    >
      <el-table-column label="Item" sortable min-width="150">
        <template slot-scope="scope">{{ inventory.find(l=> l.o_id == scope.row.item_id).item_name }}</template>
      </el-table-column>
      <el-table-column label="Amount" prop="amount" min-width="140" max-width="200">
        <template slot-scope="scope">
          <span v-if="!scope.row.editing">{{ scope.row.amount }}</span>
          <span v-else>
            <el-input-number size="small" :min="1" :max="Infinity" v-model="scope.row.n_amount"></el-input-number>
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" label="Operations" min-width="120">
        <template slot-scope="scope">
          <el-button-group v-if="scope.row.editing">
            <el-button
              @click="saveEdit(scope.row)"
              type="primary"
              size="small"
              icon="el-icon-check"
            ></el-button>
            <el-button
              @click="$set(scope.row, 'editing', false)"
              type="info"
              size="small"
              icon="el-icon-close"
            ></el-button>
          </el-button-group>
          <el-button-group v-else>
            <el-button
              @click="() => { $set(scope.row, 'editing', true); $set(scope.row, 'n_amount', scope.row.amount);}"
              type="primary"
              size="small"
              icon="el-icon-edit"
            ></el-button>
            <el-button
              @click="deleteItem(scope.row)"
              icon="el-icon-delete"
              type="danger"
              size="small"
            ></el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="userId != null" class="flex" style="margin: 8px; justify-content: end;">
      <el-popover placement="bottom" width="300" v-model="reqVisible">
        <el-select
          v-model="reqL.item_id"
          style="width: 100%"
          filterable
          remote
          reserve-keyword
          :remote-method="remoteMethod"
          :loading="reqLoading"
          placeholder="Search..."
        >
          <el-option
            v-for="item in searchList"
            :key="item.o_id"
            :label="item.item_name"
            :value="item.o_id"
          ></el-option>
        </el-select>
        <el-input-number
          size="small"
          style="width: 100%; margin-top: 8px;"
          :min="1"
          :max="10"
          v-model="reqL.amount"
        ></el-input-number>

        <hr style="margin: 16px; margin-top: 8px;" />

        <div style="text-align: right; margin: 0">
          <el-button size="mini" type="text" @click="reqVisible = false">Cancel</el-button>
          <el-button
            type="primary"
            size="mini"
            :disabled="reqL.item_id == null"
            @click="requestInventory"
          >Save</el-button>
        </div>
        <el-button slot="reference" icon="el-icon-plus" type="primary"></el-button>
      </el-popover>
    </div>
  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";

export default {
    name: "attendance-management",
    data() {
        return {
            width: "70%",
            cInventory: null,
            reqVisible: false,
            reqLoading: false,
            searchList: [],
            reqL: {
                item_id: null,
                amount: null
            }
        };
    },
    remoteMethod(query) {
        if (query !== "") {
            this.reqLoading = true;
            setTimeout(() => {
                this.reqLoading = false;
                this.searchList = this.logistics.filter((item) => {
                    return item.item_name.toLowerCase().indexOf(query.toLowerCase()) > -1;
                });
            }, 200);
        } else {
            this.searchList = this.logistics;
        }
    },
    props: ["userId"],
    computed: {...mapFields(["user", "users", "inventory"])},
    watch: {
        userId(val) {
            this.cInventory = null;
            if (val != null) {
                this.getInventory();
            }
        }
    },
    mounted() {
        this.getInventory();
    },
    methods: {
        remoteMethod(query) {
            if (query !== "") {
                this.reqLoading = true;
                setTimeout(() => {
                    this.reqLoading = false;
                    this.searchList = this.inventory.filter((item) => {
                        return (
                            item.item_name.toLowerCase().indexOf(query.toLowerCase()) > -1
                        );
                    });
                }, 200);
            } else {
                this.searchList = this.inventory;
            }
        },
        saveEdit(row) {
            this.$set(row, "editing", false);
            this.axios
                .put(
                    "/api/v1/inventory/admin/user/" + row.o_id,
                    {amount: row.n_amount},
                    {
                        headers: {"Content-Type": "application/json"},
                        credentials: "same-origin"
                    }
                )
                .then(() => {
                    row.amount = row.n_amount;
                    this.$message({
                        showClose: true,
                        message: "Amount updated successfully.",
                        type: "success"
                    });
                });
        },
        requestInventory() {
            this.reqVisible = false;
            this.axios
                .post(
                    "/api/v1/inventory/admin/user",
                    {
                        user_id: this.userId,
                        amount: this.reqL.amount,
                        item_id: this.reqL.item_id
                    },
                    {
                        headers: {"Content-Type": "application/json"},
                        credentials: "same-origin"
                    }
                )
                .then((response) => {
                    if (
                        this.cInventory.filter((l) => l.item_id == response.data.item_id)
                            .length != 0
                    ) {
                        var temp = this.cInventory.find(
                            (objv) => objv.item_id == response.data.item_id
                        );
                        var index = this.cInventory.indexOf(temp);
                        this.cInventory.splice(index, 1, response.data);
                    } else {
                        this.cInventory.push(response.data);
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors,
                        type: "error"
                    });
                });
        },
        getInventory() {
            this.axios
                .get("/api/v1/inventory/admin/user/id/" + this.userId, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.cInventory = response.data;
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors,
                        type: "error"
                    });
                });
        },
        deleteItem(row) {
            row.del_visible = false;
            this.axios
                .delete("/api/v1/inventory/admin/user/" + row.o_id, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then(() => {
                    this.$message({
                        showClose: true,
                        message: "Inventory item deleted successfuly",
                        type: "success"
                    });
                    var temp = this.cInventory.find((objv) => objv.o_id == row.o_id);
                    var index = this.cInventory.indexOf(temp);
                    this.cInventory.splice(index, 1);
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors.title,
                        type: "error"
                    });
                });
        }
    }
};
</script>
